import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import IMG1 from "../../../images/Ebook-sol-book.png";
import Down from "../../../images/ebook/download.png";
import Healthcareform from "../../components/healthcareform";
import Modal from "react-bootstrap/Modal";

function Ebooksolution(props) {
    const [show, setShow] = useState(false);
    const [showEbook, setShowEbook] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Function to handle the popup close
    const handleClose1 = () => {
        setShowEbook(false);
    };
    const handleSubmit = () => {
        // Your form submission logic here

        // Assuming the form submission was successful, hide the div
        setShowEbook(false);
    }

    // Function to show the popup after 10 seconds
    const showPopupAfterDelay = () => {
        setTimeout(() => {
            setShowEbook(true);
        }, 10000); // 10 seconds (10000 milliseconds)
    };

    // Call the function to show the popup after 10 seconds when the component mounts
    React.useEffect(() => {
        showPopupAfterDelay();
    }, []);

    return (
        <div className={`ebook-solution ${showEbook ? "show" : "hidden"}`}>
            <Container>
                <Row>
                    <div className="close-svg" onClick={handleClose1}>
                        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z" fill="#000"/>
                        </svg>
                    </div>
                    <Col xs={5} md={5} lg={5} xl={5} xxl={5}>
                        <div className="ebook-sol-img">
                            <LazyLoadImage
                                src={IMG1}
                                effect="blur"
                                alt="ebook-solution"
                                className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={7} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="ebook-sol-content">
                            <h4>Sustainable Healthcare Mobile Apps</h4>
                            {/* Add the onClick event to the image */}
                            <LazyLoadImage
                                src={Down}
                                effect="blur"
                                alt="ebook-solution"
                                className="img-fluid"
                                onClick={handleShow}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter"
                   centered>
                <div className="modal_forms">
                    <Healthcareform setShow={setShow}/>
                </div>
            </Modal>
        </div>
    );
}

export default Ebooksolution;